import { Link } from "react-router";
import NavbarLink from "./NavbarLink";

export default function Navbar(props: any) {
    return (
      <nav className={`hidden lg:flex ${ props.show ? "mobile" : "" }`}>
        <NavbarLink href="/a-pousada" title="A Pousada" />
        <NavbarLink href="/acomodacoes" title="Acomodações" />
        <NavbarLink href="/lazer" title="Lazer" />
        <NavbarLink href="/como-chegar" title="Como chegar" />
        <NavbarLink href="/fale-conosco" title="Fale conosco" />
        <div className="flex lg:hidden" title="Reservar" > 
          <div className="py-2 w-36 px-4 text-white bg-stone-500 rounded text-center">
            <Link to="/reservar">Reservar</Link>
          </div>
        </div>
      </nav>
    )
}